import { chunkArray } from '../../utilities'
import { fetchBulkSessions } from '../../lib/api'

export const reformatLatestActivity = (msg: any) => {
  const {
    content: msgBody,
    stamp,
    id: msgId,
    sessionId,
    tags: msgTags,
    action
  } = msg

  return {
    content: msgBody.body,
    date: stamp,
    id: msgId,
    media: msgBody.media,
    meta: msgBody.meta,
    sender: msgBody.user?.name ?? '',
    senderFull: msgBody.user,
    session_id: sessionId,
    tags: msgTags,
    type: action
  }
}

// Get sessions in chunks from the api
export const getBulkSessions = async (ids: string[]) => {
  if (ids.length === 0) {
    return []
  }

  // Split ids into arrays of size 100
  const chunks = chunkArray(ids, 100)

  try {
    const results = await Promise.all(
      chunks.map(chunk => fetchBulkSessions(chunk))
    )

    // Convert array of arrays to flat array with no null-ish elements
    return results.flat().filter(Boolean)
  } catch (err) {
    return []
  }
}
